package com.imobly.imobly.api.dto

import com.imobly.imobly.domain.Property
import kotlinx.serialization.Serializable

@Serializable
data class PaginatedProperty(
    val properties: List<Property> = emptyList(),
    val totalPages: Int = 0
)
